import { TabContext } from "@mui/lab";
import {
  Checkbox,
  Grid2,
  IconButton,
  Slide,
  Tab,
  TableCell,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  CommonGrid2,
  CustomTooltip,
  DotColor,
  ScoreChange,
  StatusChange,
  TabPanelView,
  TabViewSection,
} from "../../common-components/StyledComponents";
import CommonTable from "../Table";
import Search from "./components/Search";
import CommonButton from "../../../component/Button";
import SnackBar from "../../../component/SnackBar";
import {
  AddToJobPool,
  AddToJobPoolList,
  BuildPipelineSearch,
  CandidateBuildPipeline,
  SeachExternalDataBase,
  SeachExternalDataBaseRowClick,
} from "../../../redux/action/Candidate";
import { CustomizeTableCell } from "../../jobs/style";
import CandidateSourcingDownloadIco from "../../../assets/icons/CandidateSourcingDownloadIco";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { useDispatch } from "react-redux";
import { UploadJob } from "../../../redux/action/QuickMatch";
import { useSelector } from "react-redux";
import { ResumeIntelligenceUpload } from "../../../redux/action/ResumeIntelligence";
import useMeasure from "react-use-measure";
import { CustomDiv } from "../../chat-bot/style";
import { useNavigate } from "react-router-dom";
import EyeIco from "../../../assets/icons/EyeIco";
import dayjs from "dayjs";
import JobStarOnlyIco from "../../../assets/icons/JobStarOnlyIco";
import JobStarIco from "../../../assets/icons/JobStarIco";
import DialogCandidateHub from "../../jobs/candidate-scoring/components/DialogCandidateHub";
export default function BuildPipeline() {
  const dispatch = useDispatch();
  const candidateSourcing = useSelector(
    (state) => state.candidate.candidateBuildPipeline,
  );
  const [ref, bounds] = useMeasure();
  const [value, setValue] = useState(0);
  const tabData = ["Search", "History"];
  const [activeIndex, setActiveIndex] = useState({
    index: 0,
    direction: "right",
  });
  const navigate = useNavigate();
  const [data, setData] = useState({
    search: "",
    cheat_sheet: "",
    search_strategy: "",
    search_enable: false,
    table_data: false,
    // sourcing_data: [],
    sourcing_data: [
      {
        title: "Candidate Hub Results",
        header: [
          { name: "Select", direction: "asc", sort: false },
          { name: "Id", direction: "asc", sort: false },
          { name: "Name", direction: "asc", sort: false },
          { name: "Relevancy", direction: "asc", sort: false },
          { name: "Match Criteria", direction: "asc", sort: false },
          { name: "Status", direction: "asc", sort: false },
          { name: "Action", direction: "asc", sort: false },
          { name: "View", direction: "asc", sort: false },
        ],
        details: "See More",
        button: "Add Candidate",
        data: [],
      },
      {
        title: "External Search Results",
        filter: {},
        header: [
          { name: "Select", direction: "asc", sort: false },
          { name: "Name", direction: "asc", sort: false },
          {
            name: "Source",
            direction: "asc",
            sort: false,
          },
          {
            name: "Confidential",
            direction: "asc",
            sort: false,
            textAlign: "center",
          },
          {
            name: "Relevancy",
            direction: "asc",
            sort: false,
            textAlign: "center",
          },
          { name: "Match Criteria", direction: "asc", sort: false },
          {
            name: "Updated At",
            direction: "asc",
            sort: false,
          },
          {
            name: "Download",
            direction: "asc",
            sort: false,
            textAlign: "center",
          },
        ],
        details: "See More",
        data: [],
        button: "Add",
      },
    ],
    edit_enable: false,
    data: [],
    full_message_data: [],
    // data: [
    //   {
    //     icon: (
    //       <svg
    //         width="30"
    //         height="22"
    //         viewBox="0 0 21 10"
    //         fill="none"
    //         xmlns="http://www.w3.org/2000/svg"
    //       >
    //         <path
    //           d="M3.22754 2.50879C4.05878 2.50879 4.74656 2.7381 5.22754 3.15625C5.70999 3.57584 5.97555 4.178 5.97559 4.90137V9.17676C5.97556 9.36858 5.91547 9.5335 5.80273 9.65137C5.68948 9.76959 5.53119 9.83203 5.35254 9.83203C5.17652 9.83202 5.0213 9.76936 4.9082 9.65625C4.79548 9.54344 4.73001 9.38595 4.72266 9.20605V8.70508C4.25271 9.39726 3.39691 9.82513 2.50488 9.8252C1.80402 9.8252 1.20201 9.61585 0.774414 9.23926C0.345997 8.86174 0.0996866 8.32225 0.0996094 7.67871C0.0996094 7.05629 0.337597 6.54739 0.791016 6.18262C1.24117 5.82063 1.89536 5.60648 2.71777 5.55078H2.71875L4.68457 5.43945V4.99219C4.68457 4.56598 4.54506 4.23077 4.29785 4.00195C4.04971 3.77246 3.68106 3.63868 3.20215 3.63867C2.79943 3.63867 2.47332 3.72159 2.20801 3.8877C1.94296 4.05368 1.72965 4.30803 1.56152 4.66602L1.55859 4.67383C1.49918 4.77777 1.423 4.85474 1.3291 4.90527C1.2358 4.95544 1.13127 4.97557 1.01953 4.97559C0.856396 4.97559 0.708044 4.92358 0.599609 4.82324C0.490441 4.72216 0.42881 4.57857 0.428711 4.41113C0.428711 4.25539 0.480338 4.08474 0.553711 3.91797V3.91699C0.949927 3.04954 1.99589 2.50891 3.22754 2.50879ZM7.70312 0.100586C7.88877 0.100586 8.05175 0.165957 8.16797 0.288086C8.28375 0.409808 8.3457 0.579946 8.3457 0.775391V3.73242C8.80649 2.97397 9.61412 2.50308 10.583 2.50293C11.4837 2.50293 12.2395 2.86535 12.7676 3.50977C13.2941 4.15249 13.5898 5.06831 13.5898 6.16699C13.5898 7.26558 13.296 8.18134 12.7686 8.82422C12.2395 9.469 11.4806 9.83203 10.5703 9.83203C9.58564 9.83196 8.7827 9.36674 8.31348 8.60254V9.18262C8.31348 9.37087 8.24805 9.53317 8.13184 9.64844C8.01587 9.76342 7.85593 9.82512 7.67773 9.8252C7.49992 9.8252 7.34251 9.76547 7.23047 9.64941C7.11894 9.53368 7.06055 9.37095 7.06055 9.18262V0.775391C7.06055 0.580015 7.12258 0.409799 7.23828 0.288086C7.35447 0.165986 7.51754 0.100616 7.70312 0.100586ZM17.3965 2.50293C18.7417 2.50295 19.8904 3.27146 20.2295 4.30859L20.2305 4.31055C20.2578 4.39953 20.2802 4.50668 20.2803 4.59766C20.2803 4.76318 20.223 4.90693 20.1182 5.00879C20.0136 5.11029 19.8688 5.16309 19.708 5.16309C19.5742 5.16303 19.4593 5.13566 19.3584 5.06152C19.2604 4.98953 19.1857 4.88019 19.1152 4.73926L19.1143 4.73633C18.9465 4.37275 18.7197 4.10181 18.4404 3.9209C18.1612 3.74009 17.8221 3.64551 17.4219 3.64551C16.8222 3.64564 16.33 3.88884 15.9854 4.32129C15.6389 4.75603 15.4365 5.38926 15.4365 6.17383C15.4365 6.96495 15.6393 7.59479 15.9854 8.02441C16.3295 8.45155 16.8215 8.68932 17.4219 8.68945C17.8419 8.68945 18.1858 8.59284 18.4639 8.41309C18.7421 8.23311 18.9621 7.9649 19.127 7.61035L19.1279 7.60742C19.2013 7.46065 19.2783 7.34911 19.3779 7.27539C19.4809 7.19919 19.5976 7.17188 19.7344 7.17188C19.8944 7.17191 20.0371 7.22942 20.1396 7.33301C20.2421 7.43658 20.2988 7.58059 20.2988 7.74316C20.2988 7.84725 20.277 7.96223 20.2354 8.08008L20.2344 8.08105C19.8491 9.1153 18.7218 9.83198 17.416 9.83203C16.4256 9.83203 15.5984 9.47802 15.0195 8.83887C14.4417 8.20071 14.1191 7.28683 14.1191 6.17969C14.1192 5.07932 14.4385 4.15964 15.0117 3.51367C15.5861 2.86654 16.4084 2.50293 17.3965 2.50293ZM2.86621 6.56348C2.37785 6.59824 2.01392 6.72474 1.77441 6.91309C1.53845 7.09879 1.41602 7.35039 1.41602 7.65918C1.41606 7.97756 1.54829 8.24166 1.77832 8.42773C2.01007 8.61504 2.34777 8.72749 2.7627 8.72754C3.84183 8.72754 4.68431 7.96833 4.68457 7.01367V6.44727L2.86621 6.56348ZM10.3252 3.65137C9.74923 3.65137 9.25778 3.89743 8.9082 4.33203C8.55737 4.76826 8.3457 5.40027 8.3457 6.17383C8.34572 6.94402 8.5574 7.57434 8.9082 8.00977C9.25778 8.44357 9.74925 8.68945 10.3252 8.68945C10.9219 8.68944 11.4025 8.45074 11.7363 8.02246C12.0723 7.59134 12.2656 6.95922 12.2656 6.16699C12.2656 5.38152 12.0724 4.75148 11.7363 4.32031C11.4023 3.89182 10.9217 3.65138 10.3252 3.65137Z"
    //           fill="#7F56D9"
    //           stroke="#7F56D9"
    //           stroke-width="0.2"
    //         />
    //       </svg>
    //     ),
    //     name: "Keyword Search",
    //     desctiption: "Just type the Skills, Designation, Tools and Search",
    //   },
    //   {
    //     icon: (
    //       <svg
    //         width="30"
    //         height="22"
    //         viewBox="0 0 19 17"
    //         fill="none"
    //         xmlns="http://www.w3.org/2000/svg"
    //       >
    //         <path
    //           d="M17.4167 15.75V14.0833C17.4167 12.5301 16.3544 11.2251 14.9167 10.855M12 0.992299C13.2216 1.48679 14.0833 2.68443 14.0833 4.08333C14.0833 5.48224 13.2216 6.67988 12 7.17437M13.25 15.75C13.25 14.1969 13.25 13.4203 12.9963 12.8077C12.658 11.991 12.009 11.342 11.1923 11.0037C10.5797 10.75 9.80314 10.75 8.25 10.75H5.75C4.19686 10.75 3.42029 10.75 2.80772 11.0037C1.99096 11.342 1.34205 11.991 1.00373 12.8077C0.75 13.4203 0.75 14.1969 0.75 15.75M10.3333 4.08333C10.3333 5.92428 8.84095 7.41667 7 7.41667C5.15905 7.41667 3.66667 5.92428 3.66667 4.08333C3.66667 2.24238 5.15905 0.75 7 0.75C8.84095 0.75 10.3333 2.24238 10.3333 4.08333Z"
    //           stroke="#7F56D9"
    //           stroke-width="1.5"
    //           stroke-linecap="round"
    //           stroke-linejoin="round"
    //         />
    //       </svg>
    //     ),
    //     name: "Find a Twin",
    //     desctiption:
    //       "Choose a candidate from hub to find people with same skills.",
    //   },
    //   {
    //     icon: (
    //       <svg
    //         width="30"
    //         height="18"
    //         viewBox="0 0 18 18"
    //         fill="none"
    //         xmlns="http://www.w3.org/2000/svg"
    //       >
    //         <path
    //           fill-rule="evenodd"
    //           clip-rule="evenodd"
    //           d="M7.44263 0.20801H7.42681C7.33875 0.207994 7.2703 0.207986 7.2055 0.211909C6.38346 0.2617 5.66362 0.780529 5.35644 1.54464C5.33223 1.60488 5.31057 1.66987 5.28275 1.75337L5.27776 1.76834L5.25787 1.82802C5.24315 1.87218 5.23905 1.88435 5.23547 1.89421C5.11154 2.23682 4.69971 2.52274 4.26402 2.53378L2.85364 2.60278C2.24416 2.67439 1.72229 2.82687 1.28127 3.18571C1.12723 3.31104 0.986443 3.45184 0.861102 3.60588C0.502265 4.04689 0.349784 4.56876 0.278172 5.17824C0.208971 5.76722 0.208978 6.5078 0.208986 7.42638V7.46297V7.48723C0.208963 7.70731 0.20894 7.91367 0.226567 8.08739C0.246071 8.27964 0.290955 8.48375 0.413529 8.68088C0.453374 8.74499 0.498498 8.80561 0.548428 8.8622C0.679521 9.01072 0.831769 9.10654 0.984552 9.17739C0.986784 10.4295 1.00264 11.695 1.11499 12.7789C1.18083 13.4139 1.28186 14.0102 1.44212 14.5185C1.59977 15.0186 1.83256 15.4921 2.20104 15.8196C2.83937 16.387 3.64275 16.6372 4.64564 16.7571C5.63007 16.8747 6.89183 16.8747 8.50263 16.8747H8.58201C10.1928 16.8747 11.4546 16.8747 12.439 16.7571C13.4419 16.6372 14.2453 16.387 14.8836 15.8196C15.2521 15.4921 15.4849 15.0186 15.6425 14.5185C15.8028 14.0102 15.9038 13.4139 15.9697 12.7789C16.082 11.695 16.0978 10.4295 16.1001 9.17739C16.2529 9.10654 16.4051 9.01072 16.5362 8.8622C16.5861 8.80561 16.6312 8.74499 16.6711 8.68088C16.7937 8.48375 16.8386 8.27964 16.8581 8.08739C16.8757 7.91367 16.8757 7.70731 16.8757 7.48723V7.4263C16.8757 6.50779 16.8757 5.76722 16.8065 5.17824C16.7349 4.56876 16.5824 4.04689 16.2236 3.60588C16.0982 3.45184 15.9574 3.31104 15.8034 3.18571C15.3623 2.82687 14.8405 2.67439 14.231 2.60278L12.8206 2.53378C12.3851 2.52275 11.9735 2.23693 11.8495 1.8942C11.846 1.8844 11.8418 1.87196 11.8271 1.82802L11.8022 1.75333C11.7744 1.66985 11.7528 1.60487 11.7285 1.54465C11.4214 0.780529 10.7015 0.2617 9.87953 0.211909C9.81472 0.207986 9.74619 0.207994 9.65821 0.20801H7.44263ZM5.10846 3.69638H5.13839H11.9463H11.9762C12.924 3.69641 13.5874 3.69795 14.0953 3.75762C14.5958 3.81643 14.8694 3.9248 15.0695 4.08765C15.1619 4.16285 15.2464 4.24733 15.3216 4.33975C15.4844 4.5399 15.5928 4.81345 15.6516 5.31393C15.7119 5.82711 15.7129 6.49917 15.7129 7.46297C15.7129 7.71576 15.7122 7.86212 15.7012 7.97002C15.6947 8.03374 15.6866 8.05964 15.6836 8.06708C15.6779 8.07615 15.6715 8.08468 15.6645 8.09266C15.6582 8.0977 15.6358 8.11297 15.5766 8.13747C15.4764 8.17902 15.3364 8.22173 15.0943 8.29437L11.0617 9.50413V9.31654C11.0617 8.78134 10.6279 8.34754 10.0927 8.34754H6.99193C6.45678 8.34754 6.02294 8.78134 6.02294 9.31654V9.50413L1.99032 8.29437C1.74819 8.22173 1.60823 8.17902 1.50804 8.13747C1.44885 8.11297 1.4264 8.0977 1.42012 8.09266L6.02294 9.50413L1.40112 8.06708C1.39806 8.05964 1.38989 8.03374 1.38342 7.97002C1.37247 7.86212 1.37178 7.71576 1.37178 7.46297C1.37178 6.49917 1.37272 5.82711 1.43302 5.31393C1.49183 4.81345 1.6002 4.5399 1.76305 4.33975C1.83825 4.24733 1.92272 4.16285 2.01515 4.08765C2.2153 3.9248 2.48885 3.81643 2.98933 3.75762C3.49717 3.69795 4.16063 3.69641 5.10846 3.69638ZM7.44263 1.3708C7.33147 1.3708 7.30077 1.37106 7.27581 1.37258C6.90214 1.3952 6.57494 1.63104 6.43531 1.97836C6.42597 2.00161 6.41602 2.03062 6.38088 2.13605L6.35889 2.202C6.34724 2.23697 6.33817 2.26418 6.32892 2.28975C6.29834 2.3743 6.26219 2.45564 6.22106 2.53359H10.8639C10.8228 2.45565 10.7867 2.37431 10.756 2.28977C10.7468 2.2642 10.7377 2.23697 10.7261 2.202L10.7041 2.13605C10.669 2.03062 10.659 2.00161 10.6497 1.97836C10.5101 1.63104 10.1829 1.3952 9.80922 1.37258C9.78418 1.37106 9.75356 1.3708 9.6424 1.3708H7.44263ZM2.1486 9.55584C2.15387 10.6696 2.17629 11.7397 2.27159 12.659C2.33347 13.2559 2.42401 13.7657 2.55111 14.1689C2.68082 14.5804 2.83118 14.824 2.97356 14.9506C3.35695 15.2913 3.88664 15.4953 4.78362 15.6025C5.69099 15.7109 6.88324 15.7119 8.54232 15.7119C10.2014 15.7119 11.3936 15.7109 12.301 15.6025C13.198 15.4953 13.7277 15.2913 14.1111 14.9506C14.2535 14.824 14.4038 14.5804 14.5336 14.1689C14.6606 13.7657 14.7512 13.2559 14.813 12.659C14.9084 11.7397 14.9308 10.6696 14.936 9.55584L11.0617 10.7181V10.9921C11.0617 11.3883 10.8205 11.7447 10.4525 11.8918L9.90984 12.1089C9.03201 12.46 8.05271 12.46 7.1748 12.1089L6.63206 11.8918C6.26417 11.7447 6.02294 11.3883 6.02294 10.9921V10.7181L2.1486 9.55584ZM7.18573 9.51033V10.8609L7.60666 11.0292C8.20728 11.2696 8.87736 11.2696 9.47798 11.0292L9.89891 10.8609V9.51033H7.18573Z"
    //           fill="#7F56D9"
    //         />
    //         <path
    //           d="M6.02294 9.50413V9.31654C6.02294 8.78134 6.45678 8.34754 6.99193 8.34754H10.0927C10.6279 8.34754 11.0617 8.78134 11.0617 9.31654V9.50413L15.0943 8.29437C15.3364 8.22173 15.4764 8.17902 15.5766 8.13747C15.6358 8.11297 15.6582 8.0977 15.6645 8.09266C15.6715 8.08468 15.6779 8.07615 15.6836 8.06708C15.6866 8.05964 15.6947 8.03375 15.7012 7.97002C15.7122 7.86212 15.7129 7.71576 15.7129 7.46297C15.7129 6.49917 15.7119 5.82711 15.6516 5.31393C15.5928 4.81345 15.4844 4.5399 15.3216 4.33975C15.2464 4.24733 15.1619 4.16285 15.0695 4.08765C14.8694 3.9248 14.5958 3.81643 14.0953 3.75762C13.5874 3.69795 12.924 3.69641 11.9762 3.69638H11.9463H5.13839H5.10846C4.16063 3.69641 3.49717 3.69795 2.98933 3.75762C2.48885 3.81643 2.2153 3.9248 2.01515 4.08765C1.92272 4.16285 1.83825 4.24733 1.76305 4.33975C1.6002 4.5399 1.49183 4.81345 1.43302 5.31393C1.37272 5.82711 1.37178 6.49917 1.37178 7.46297C1.37178 7.71576 1.37247 7.86212 1.38342 7.97002C1.38989 8.03375 1.39806 8.05964 1.40112 8.06708L6.02294 9.50413ZM6.02294 9.50413L1.99032 8.29437C1.74819 8.22173 1.60823 8.17902 1.50804 8.13747C1.44885 8.11297 1.4264 8.0977 1.42012 8.09266L6.02294 9.50413ZM7.44263 0.20801H7.42681C7.33875 0.207994 7.2703 0.207986 7.2055 0.211909C6.38346 0.2617 5.66362 0.780529 5.35644 1.54464C5.33223 1.60488 5.31057 1.66987 5.28275 1.75337L5.27776 1.76834L5.25787 1.82802C5.24315 1.87218 5.23905 1.88435 5.23547 1.89421C5.11154 2.23682 4.69971 2.52274 4.26402 2.53378L2.85364 2.60278C2.24416 2.67439 1.72229 2.82687 1.28127 3.18571C1.12723 3.31104 0.986443 3.45184 0.861102 3.60588C0.502265 4.04689 0.349784 4.56876 0.278172 5.17824C0.208971 5.76722 0.208978 6.5078 0.208986 7.42638V7.46297V7.48723C0.208963 7.70731 0.20894 7.91367 0.226567 8.08739C0.246071 8.27964 0.290955 8.48375 0.413529 8.68088C0.453374 8.74499 0.498498 8.80561 0.548428 8.8622C0.679521 9.01072 0.831769 9.10654 0.984552 9.17739C0.986784 10.4295 1.00264 11.695 1.11499 12.7789C1.18083 13.4139 1.28186 14.0102 1.44212 14.5185C1.59977 15.0186 1.83256 15.4921 2.20104 15.8196C2.83937 16.387 3.64275 16.6372 4.64564 16.7571C5.63007 16.8747 6.89183 16.8747 8.50263 16.8747H8.58201C10.1928 16.8747 11.4546 16.8747 12.439 16.7571C13.4419 16.6372 14.2453 16.387 14.8836 15.8196C15.2521 15.4921 15.4849 15.0186 15.6425 14.5185C15.8028 14.0102 15.9038 13.4139 15.9697 12.7789C16.082 11.695 16.0978 10.4295 16.1001 9.17739C16.2529 9.10654 16.4051 9.01072 16.5362 8.8622C16.5861 8.80561 16.6312 8.74499 16.6711 8.68088C16.7937 8.48375 16.8386 8.27964 16.8581 8.08739C16.8757 7.91367 16.8757 7.70731 16.8757 7.48723V7.4263C16.8757 6.50779 16.8757 5.76722 16.8065 5.17824C16.7349 4.56876 16.5824 4.04689 16.2236 3.60588C16.0982 3.45184 15.9574 3.31104 15.8034 3.18571C15.3623 2.82687 14.8405 2.67439 14.231 2.60278L12.8206 2.53378C12.3851 2.52275 11.9735 2.23693 11.8495 1.8942C11.846 1.8844 11.8418 1.87196 11.8271 1.82802L11.8022 1.75333C11.7744 1.66985 11.7528 1.60487 11.7285 1.54465C11.4214 0.780529 10.7015 0.2617 9.87953 0.211909C9.81472 0.207986 9.74619 0.207994 9.65821 0.20801H7.44263ZM7.44263 1.3708C7.33147 1.3708 7.30077 1.37106 7.27581 1.37258C6.90214 1.3952 6.57494 1.63104 6.43531 1.97836C6.42597 2.00161 6.41602 2.03062 6.38088 2.13605L6.35889 2.202C6.34724 2.23697 6.33817 2.26418 6.32892 2.28975C6.29834 2.3743 6.26219 2.45564 6.22106 2.53359H10.8639C10.8228 2.45565 10.7867 2.37431 10.756 2.28977C10.7468 2.2642 10.7377 2.23697 10.7261 2.202L10.7041 2.13605C10.669 2.03062 10.659 2.00161 10.6497 1.97836C10.5101 1.63104 10.1829 1.3952 9.80922 1.37258C9.78418 1.37106 9.75356 1.3708 9.6424 1.3708H7.44263ZM2.1486 9.55584C2.15387 10.6696 2.17629 11.7397 2.27159 12.659C2.33347 13.2559 2.42401 13.7657 2.55111 14.1689C2.68082 14.5804 2.83118 14.824 2.97356 14.9506C3.35695 15.2913 3.88664 15.4953 4.78362 15.6025C5.69099 15.7109 6.88324 15.7119 8.54232 15.7119C10.2014 15.7119 11.3936 15.7109 12.301 15.6025C13.198 15.4953 13.7277 15.2913 14.1111 14.9506C14.2535 14.824 14.4038 14.5804 14.5336 14.1689C14.6606 13.7657 14.7512 13.2559 14.813 12.659C14.9084 11.7397 14.9308 10.6696 14.936 9.55584L11.0617 10.7181V10.9921C11.0617 11.3883 10.8205 11.7447 10.4526 11.8918L9.90984 12.1089C9.03201 12.46 8.05271 12.46 7.1748 12.1089L6.63206 11.8918C6.26417 11.7447 6.02294 11.3883 6.02294 10.9921V10.7181L2.1486 9.55584ZM7.18573 9.51033V10.8609L7.60666 11.0292C8.20728 11.2696 8.87736 11.2696 9.47798 11.0292L9.89891 10.8609V9.51033H7.18573Z"
    //           stroke="#7F56D9"
    //           stroke-width="0.416667"
    //         />
    //       </svg>
    //     ),
    //     name: "Job description Match",
    //     desctiption: "Upload a Job description to find candidates that match.",
    //   },
    //   {
    //     icon: (
    //       <svg
    //         width="30"
    //         height="17"
    //         viewBox="0 0 14 17"
    //         fill="none"
    //         xmlns="http://www.w3.org/2000/svg"
    //       >
    //         <path
    //           fill-rule="evenodd"
    //           clip-rule="evenodd"
    //           d="M2.33333 0C1.04467 0 0 1.03789 0 2.31818V14.6818C0 15.9621 1.04467 17 2.33333 17H11.6667C12.9554 17 14 15.9621 14 14.6818V6.04924C14 5.43442 13.7541 4.84478 13.3166 4.41004L9.56114 0.67898C9.12357 0.244236 8.53004 0 7.91124 0H2.33333ZM1.55556 2.31818C1.55556 1.89142 1.90378 1.54545 2.33333 1.54545H7V5.40909C7 6.26262 7.69642 6.95455 8.55556 6.95455H12.4444V14.6818C12.4444 15.1086 12.0962 15.4545 11.6667 15.4545H2.33333C1.90378 15.4545 1.55556 15.1086 1.55556 14.6818V2.31818ZM12.1223 5.40909L8.55556 1.86553V5.40909H12.1223Z"
    //           fill="#7F56D9"
    //         />
    //       </svg>
    //     ),
    //     name: "Resume Match",
    //     desctiption:
    //       "Upload a resume to find profiles with similar experience.",
    //   },
    // ],
    loading: false,
    search_external_loading: false,
    message: [],
  });
  const [pendingValidResumes, setPendingValidResumes] = useState([]);
const [dialogErrorMessage, setDialogErrorMessage] = useState("");
const [statusDialog, setSelectDialog] = useState({
  open: false,
  disabled: false,
  changeStatusLoading: false,
  cancelLoading: false,
  changeLoading: false,
  value: "Active",
  id: "",
  condition: true,
  allInvalid: false,
});

const handleChangeStatusClose = () => {
  setSelectDialog({
    open: false,
    disabled: false,
    changeStatusLoading: false,
    cancelLoading: false,
    changeLoading: false,
    value: "Active",
    id: "",
    condition: true,
    allInvalid: false,
  });
  setCheckSelected({
    candidateSelect: [],
    externalSelect: [],
  });

  // ✅ Reset pipeline progress state that was set before dialog opened
  const resetUpdated = { data: [], status: "" };
  localStorage.setItem("Candidate BuildPipeline", JSON.stringify(resetUpdated));
  dispatch(CandidateBuildPipeline({ data: [], status: "" }));
  setPendingValidResumes([]);
};
  const processConditionCheck =
    candidateSourcing &&
    candidateSourcing.data.length !== 0 &&
    candidateSourcing.status !== "process";
  const [checkSelected, setCheckSelected] = useState({
    candidateSelect: [],
    externalSelect: [],
  });
  const [externalValidating, setExternalValidating] = useState(false);
  const [jobTitles, setJobTitles] = useState({
    data: [],
    value: null,
    droppDown_data: [
      {
        name: "Add to Job",
        value: "Add to Job",
      },
      { name: "Add to CHUB", value: "Add to CHUB" },
    ],
    droppDown_value: null,
    job_value: null,
  });
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleTabChange = (_, newValue) => {
    setValue(newValue);
  };

  const [historyHeaderData, setHistoryHeaderData] = useState([
    { name: "Searched for" },
    { name: "Search type" },
    { name: "Results" },
    { name: "Added" },
    { name: "Platform" },
    {},
  ]);

  const headerData = [
    { name: "Select" },
    { name: "Id" },
    { name: "Name" },
    { name: "Relevancy" },
    { name: "Match Criteria" },
    { name: "Action" },
    { name: "Download" },
  ];

  const handleNewSearch = () => {
    dispatch(
      CandidateBuildPipeline({
        data: [],
        status: "",
      }),
    );
    setCheckSelected((prev) => ({
      ...prev,
      externalSelect: [],
      candidateSelect: [],
    }));
    setData((prev) => ({
      ...prev,
      search: "",
      search_strategy: "",
      message: [],
      search_enable: false,
      table_data: false,
      full_message_data: [],
    }));
  };

  console.log(jobTitles, "sfkjshfksfhsjkf");

  const handleFetchSearch = async (value) => {
    setData((prev) => ({
      ...prev,
      loading: true,
    }));
    try {
      let payload = [...data.message, ...[{ sender: "user", text: value }]];
      let listData = await BuildPipelineSearch(payload);
      let message = [
        { sender: "user", text: value },
        { sender: "bot", text: listData?.data?.boolean_search_string },
      ];
      let full_message_data = [
        ...data.full_message_data,
        {
          search_strategy: listData?.data?.boolean_search_string,
          cheat_sheet: listData?.data?.search_strategy?.cheat_sheet,
          text: value,
          search_criteria: listData?.data?.search_criteria,
        },
      ];
      setData((prev) => ({
        ...prev,
        search_strategy: listData?.data?.boolean_search_string,
        cheat_sheet: listData?.data?.search_strategy?.cheat_sheet,
        message: [...prev.message, ...message],
        full_message_data: full_message_data,
        loading: false,
        search: "",
      }));
      setActiveIndex((prev) => ({
        ...prev,
        index: full_message_data.length - 1,
        direction: "right",
      }));
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
      setData((prev) => ({
        ...prev,
        loading: false,
        search_enable: false,
        edit_enable: false,
        table_data: false,
      }));
    }
  };

  const handleSearch = (e, condition) => {
    let value =
      condition === "click" || condition === "inside_click"
        ? data.search
        : e.target.value;
    setData((prev) => ({
      ...prev,
      ...(condition === "inside_search"
        ? {
            search: value,
            search_enable: true,
            // edit_enable: value && e.key === "Enter" ? false : true,
            edit_enable: true,
            table_data: false,
          }
        : condition === "search"
        ? {
            search: value,
            search_enable: value && e.key === "Enter" ? true : false,
            // edit_enable: false,
            edit_enable: true,
            table_data: false,
          }
        : value && condition === "inside_click"
        ? { search_enable: true, edit_enable: true, table_data: false }
        : value && condition === "click"
        ? { search_enable: true, edit_enable: true, table_data: false }
        : {}),
    }));
    if (
      value &&
      (e.key === "Enter" ||
        condition === "click" ||
        condition === "inside_click")
    ) {
      handleFetchSearch(value);
    }
    setCheckSelected((prev) => ({
      ...prev,
      externalSelect: [],
      candidateSelect: [],
    }));
  };

  const handleEditSearch = () => {
    setData((prev) => ({
      ...prev,
      edit_enable: true,
      table_data: false,
    }));
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const fetchJobTitles = async () => {
    try {
      const response = await AddToJobPoolList();
      const jobData = response.data;
      if (Array.isArray(jobData)) {
        const jobOptions = jobData.map((job) => ({
          label: `${job.unique_id} - ${job.title} - ${job.company}`,
          value: job.id,
        }));
        setJobTitles((prev) => ({
          ...prev,
          data: jobOptions,
          droppDown_value: null,
          value: null,
        }));
      } else {
        setJobTitles((prev) => ({
          ...prev,
          data: [],
          value: null,
        }));
      }
    } catch (error) {
      setJobTitles((prev) => ({
        ...prev,
        data: [],
        droppDown_value: null,
        value: null,
      }));
    }
  };

  const handleSearchExternalDatabase = async () => {
    setData((prev) => ({
      ...prev,
      search_external_loading: true,
      edit_enable: false,
    }));
    setCheckSelected((prev) => ({
      ...prev,
      externalSelect: [],
    }));
    try {
      let payload = {
        search_string:
          data?.full_message_data?.[activeIndex.index]?.search_strategy,
        search_criteria:
          data?.full_message_data?.[activeIndex.index]?.search_criteria,
      };

      let getData = await SeachExternalDataBase(payload);
      await fetchJobTitles();
      setData((prev) => ({
        ...prev,
        table_data: true,
        sourcing_data:
          prev.sourcing_data.map((item, index) => {
            if (index === 0) {
              return {
                ...prev.sourcing_data[index],
                data: getData?.data?.chub_resumes,
              };
            } else {
              return {
                ...prev.sourcing_data[index],
                filter: getData?.data?.monster_filters,
                data: getData?.data?.l3_resumes,
              };
            }
          }) || [],

        // getData.data,
        search_external_loading: false,
      }));
      setJobTitles((prev) => ({
        ...prev,
        job_value: null,
        droppDown_value: null,
        value: null,
      }));
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
      setData((prev) => ({
        ...prev,
        search_external_loading: false,
      }));
    }
  };

  const handleCheckExternalRow = (row) => {
    setCheckSelected((prev) => {
      const selected = prev.externalSelect.some(
        (item) => item.ResumeID === row.ResumeID,
      );
      let newSelected;

      if (selected) {
        newSelected = prev.externalSelect.filter(
          (item) => item.ResumeID !== row.ResumeID,
        );
      } else {
        newSelected = [...prev.externalSelect, row];
      }
      const checkData = newSelected.map((item) => ({
        ...item,
        file: {
          progress: 1,
          buffer: 1,
          visible: false,
        },
      }));
      const updated = {
        data: checkData,
        status: "process",
      };
      localStorage.setItem("Candidate BuildPipeline", JSON.stringify(updated));
      dispatch(
        CandidateBuildPipeline({
          data: updated.data,
          status: "process",
        }),
      );

      return { ...prev, externalSelect: newSelected };
    });
  };

  const handleCheckRow = (row) => {
    setCheckSelected((prev) => {
      const selected = prev.candidateSelect.some((item) => item.id === row.id);
      let newSelected;

      if (selected) {
        newSelected = prev.candidateSelect.filter((item) => item.id !== row.id);
      } else {
        const { match_criteria_normal, match_criteria_deep, ...safeRow } = row;
        newSelected = [...prev.candidateSelect, safeRow];
      }
      const checkData = newSelected.map((item) => ({
        ...item,
        file: {
          progress: 1,
          buffer: 1,
          visible: false,
        },
      }));
      const updated = {
        data: checkData,
        status: "process",
      };
      localStorage.setItem("Candidate BuildPipeline", JSON.stringify(updated));
      dispatch(
        CandidateBuildPipeline({
          data: updated.data,
          status: "process",
        }),
      );

      return { ...prev, candidateSelect: newSelected };
    });
  };

  const handleViewClick = (row) => {
    const URL = process.env.REACT_APP_URL;
    window.open(
      `${URL}/candidates/candidate-view?view-id=${row.id}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const handleHubTableBodyData = (row) => {
    return (
      <>
        <TableCell>
          <Checkbox
            color="primary"
            checked={checkSelected.candidateSelect.some(
              (item) => item.id === row.id,
            )}
            onChange={() => handleCheckRow(row)}
          />
        </TableCell>
        <TableCell>{row.order_no || "-"}</TableCell>
        <TableCell>{row.name || "-"}</TableCell>
        <TableCell>
          <ScoreChange>{row.relevancy_score}%</ScoreChange>
        </TableCell>
        <TableCell>
          <CommonGrid2 display={"flex"} gap={"10px"} flexWrap={"wrap"}>
            {(row.match_criteria_normal &&
              row.match_criteria_normal.map((item, index) => {
                console.log(item, "item");
                return (
                  <CustomDiv
                    border="1px solid #D0D5DD"
                    padding="2px"
                    borderRadius="5px"
                    fontSize="10px"
                    background="#F9F5FF"
                  >
                    <Typography
                      textTransform="capitalize"
                      fontSize="13px"
                      display="flex"
                      alignItems="center"
                      gap="5px"
                    >
                      {item.name}

                      {item.name === "title" && item.is_inferred_title && (
                        <CustomTooltip
                          title={
                            <Typography
                              fontSize="13px"
                              display="flex"
                              alignItems="center"
                              gap="4px"
                              fontWeight="500"
                            >
                              <JobStarOnlyIco fill="white" /> Inferred
                            </Typography>
                          }
                          placement="top"
                          backgroundColor="#0070F2"
                          borderRadius="50px"
                        >
                          <Typography
                            component="span"
                            display="flex"
                            alignItems="center"
                            sx={{ cursor: "pointer" }}
                          >
                            <JobStarIco />
                          </Typography>
                        </CustomTooltip>
                      )}
                    </Typography>
                  </CustomDiv>
                );
              })) ||
              "-"}
          </CommonGrid2>
        </TableCell>
        <TableCell>
          <StatusChange>
            <DotColor
              color={
                row.status === "Active"
                  ? "green"
                  : row.status === "Hold"
                    ? "orange"
                    : "#667085"
              }
            />
            {row.status || "-"}
          </StatusChange>
        </TableCell>
        <TableCell>
          {row.is_added_to_job ? (
            <CommonGrid2 display={"flex"} gap={"10px"}>
              <TaskAltIcon sx={{ color: "#17B26A", fontSize: "20px" }} />
              <Typography variant="body2" color="#17B26A">
                Added to Job
              </Typography>
            </CommonGrid2>
          ) : (
            "-"
          )}
        </TableCell>

        <TableCell>
          <IconButton onClick={() => handleViewClick(row)}>
            <EyeIco />
          </IconButton>
        </TableCell>
      </>
    );
  };

  const handleSearchTableBodyData = (row) => {
    return (
      <>
        <TableCell>
          <Checkbox
            color="primary"
            checked={checkSelected.externalSelect.some(
              (item) => item.ResumeID === row.ResumeID,
            )}
            // disabled={!row.binary_text}
            onChange={() => handleCheckExternalRow(row)}
          />
        </TableCell>
        <TableCell>{row.name || "-"}</TableCell>
        <TableCell>{row.source || "-"}</TableCell>
        <CustomizeTableCell textAlign="center">
          <ScoreChange
            margin="auto"
            background={row?.is_confidential ? "#ECFDF3" : "#ffe6e7"}
            color={row?.is_confidential ? "#067647" : "#ff474b"}
            border={
              row?.is_confidential ? "1px solid #067647" : "1px solid #ff474b"
            }
          >
            {row?.is_confidential === true
              ? "Yes"
              : row?.is_confidential === false
                ? "No"
                : "-"}
          </ScoreChange>
        </CustomizeTableCell>
        <TableCell>
          <ScoreChange margin="auto">{row.relevancy}%</ScoreChange>
        </TableCell>
        <TableCell>{row.match || "-"}</TableCell>
        <TableCell>{dayjs(row.updated_date).format("MMM DD, YYYY")}</TableCell>
        {/* <TableCell>
          {row.is_added_to_job ? (
            <CommonGrid2 display={"flex"} gap={"10px"}>
              <TaskAltIcon sx={{ color: "#17B26A", fontSize: "20px" }} />
              <Typography variant="body2" color="#17B26A">
                Added to Job
              </Typography>
            </CommonGrid2>
          ) : (
            "-"
          )}
        </TableCell> */}
        <CustomizeTableCell textAlign="center">
          {/* {!row.binary_text ? (
            "-"
          ) : ( */}
          <IconButton onClick={() => handleDownload(row)}>
            <CandidateSourcingDownloadIco />
          </IconButton>
        </CustomizeTableCell>
        {/* )} */}
      </>
    );
  };

  const handleDownload = async (row) => {
    try {
      let payload = {
        resumes: [{ id: row.ResumeID, source: row.source, name: row.name }],
      };
      const data = await SeachExternalDataBaseRowClick(payload);
      const getData = data?.data?.[0];
      if (!getData?.binary_text || getData?.binary_text === "none") {
      setDialogErrorMessage(
        `The following profile(s) are missing resume documents and cannot be downloaded:\n\n• ${row.name}`
      );
      setSelectDialog({
        open: true,
        disabled: false,
        changeStatusLoading: false,
        cancelLoading: false,
        changeLoading: false,
        value: "Active",
        id: "",
        condition: true,
        allInvalid: true, 
      });
      return;
    }
      const base64Data = getData.binary_text;
      const fileType = getData.document_type?.toLowerCase();
      const fileName = getData.ResumeTitle || `file.${fileType || "pdf"}`;
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length)
        .fill(0)
        .map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      let mimeType = "application/octet-stream";
      if (fileType === "pdf") mimeType = "application/pdf";
      else if (fileType === "docx")
        mimeType =
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

      const blob = new Blob([byteArray], { type: mimeType });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
    }
  };

  const handleDetails = (i, recordIndex) => {
    setData((prev) => {
      return {
        ...prev,
        sourcing_data: prev.sourcing_data.map((item, index) => {
          if (index === i) {
            return {
              ...prev.sourcing_data[index],
              details: item.details === "See More" ? "Hide More" : "See More",
            };
          } else {
            return {
              ...prev.sourcing_data[index],
            };
          }
        }),
      };
    });
  };

  const processJsonResponse = async (jsonResponse, type) => {
    const { success, data, message, resume_id } = jsonResponse;
    if (data && Object?.keys(data)?.length === 0) {
      const existing =
        JSON.parse(localStorage.getItem("Candidate BuildPipeline")) || {};
      let checkData = existing.data.map((item) => {
        return {
          ...item,
          file: {
            ...item.file,
            message: message,
            visible: true,
            progress_message: data.progress_message,
          },
        };
      });
      const updated = {
        data: checkData,
        status: "fail",
      };

      localStorage.setItem("Candidate BuildPipeline", JSON.stringify(updated));
      dispatch(
        CandidateBuildPipeline({
          data: updated.data,
          status: "fail",
        }),
      );

      setSnackbarState({
        open: true,
        message: message,
        severity: "error",
      });
    } else if (success && data?.percent !== undefined) {
      const existing =
        JSON.parse(localStorage.getItem("Candidate BuildPipeline")) || {};
      let checkData = existing.data.map((item) => {
        return {
          ...item,
          file: (
            type === "internal"
              ? item.id === resume_id
              : item.name === data.current_resume
          )
            ? {
                ...item.file,
                progress: data.percent,
                buffer: data.percent,
                visible: false,
                progress_message: data.progress_message,
              }
            : item.file,
        };
      });
      const updated = {
        data: checkData,
        status: "Inprogress",
      };
      localStorage.setItem("Candidate BuildPipeline", JSON.stringify(updated));
      dispatch(
        CandidateBuildPipeline({
          data: updated.data,
          status: data.percent === 100 ? "success" : "Inprogress",
        }),
      );
    } else if (data && data?.length !== 0 && data[0]?.id) {
      dispatch(
        CandidateBuildPipeline({
          data: [],
          status: "",
        }),
      );
      setJobTitles((prev) => ({
        ...prev,
        droppDown_value: "",
        value: "",
        job_value: "",
      }));
    } else if (!success) {
      const existing =
        JSON.parse(localStorage.getItem("Candidate BuildPipeline")) || {};
      let checkData = existing.data.map((item) => {
        return {
          ...item,
          file: (
            type === "internal"
              ? item.id === resume_id || data.length === 0
              : item.name === data.current_resume || data.length === 0
          )
            ? { ...item.file, visible: true, message: message }
            : { ...item.file, delete: true },
        };
      });
      const updated = {
        data: checkData,
        status: "fail",
      };

      localStorage.setItem("Candidate BuildPipeline", JSON.stringify(updated));
      dispatch(
        CandidateBuildPipeline({
          data: updated.data,
          status: "fail",
        }),
      );
      setJobTitles((prev) => ({
        ...prev,
        data: [],
        droppDown_value: "",
        value: "",
        job_value: "",
      }));
    }
  };
   const StatusFooter = () => (
    <CommonGrid2
      display="flex"
      justifyContent="center"
      gap="1rem"
      marginTop="1.5rem"
      width="100%"
    >
      <CommonButton
        value={statusDialog.allInvalid ? "Close" : "Cancel"}
        variant="outlined"
        borderColor="#D0D5DD"
        color="#344054"
        fontWeight="700"
        padding={"10px 0"}
        width="100%"
        onClick={handleChangeStatusClose}
      />
      {!statusDialog.allInvalid && (
        <CommonButton
          value="Proceed"
          variant="contained"
          background="#7F56D9"
          fontWeight="700"
          padding={"10px 0"}
          width="100%"
          onClick={handleProceedWithRemaining}
        />
      )}
    </CommonGrid2>
  );

  const handleAddToJob = async () => {
    if (jobTitles.job_value === null) {
      setJobTitles((prev) => ({
        ...prev,
        job_value: "",
      }));
    } else if (jobTitles.job_value === "") {
      return null;
    } else {
      const existing =
        JSON.parse(localStorage.getItem("Candidate BuildPipeline")) || {};
      let checkData = checkSelected.candidateSelect.map((item) => {
        return {
          ...item,
          result_title: "Candidate Search Results",
          file: {
            progress: 1,
            buffer: 1,
            visible: false,
          },
        };
      });
      const updated = {
        ...existing,
        data: checkData,
        status: "Inprogress",
      };

      localStorage.setItem("Candidate BuildPipeline", JSON.stringify(updated));
      dispatch(
        CandidateBuildPipeline({
          data: updated.data,
          status: "Inprogress",
        }),
      );

      const resumeIds = checkSelected?.candidateSelect?.map((item) => item.id);

      try {
        const payload = {
          job: jobTitles.job_value?.value,
          resumes: resumeIds,
        };

        const response = await AddToJobPool(payload);
        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";

        while (true) {
          const { value, done } = await reader.read();
          if (done) break;
          const chunk = decoder.decode(value, { stream: true });
          buffer += chunk;
          let boundaryIndex;
          while ((boundaryIndex = buffer.indexOf("}\n")) !== -1) {
            const jsonString = buffer.slice(0, boundaryIndex + 1);
            buffer = buffer.slice(boundaryIndex + 1);
            const jsonResponse = JSON.parse(jsonString);
            try {
              await processJsonResponse(jsonResponse, "internal");
            } catch (e) {
              let checkData = existing.map((item) => {
                return {
                  ...item,
                  file:
                    item.id === jsonResponse.resume_id
                      ? {
                          ...item.file,
                          message: "Error during the request",
                          visible: true,
                        }
                      : item.file,
                };
              });
              const updated = {
                ...existing,

                data: checkData,
                status: "fail",
              };

              localStorage.setItem(
                "Candidate BuildPipeline",
                JSON.stringify(updated),
              );
              dispatch(
                CandidateBuildPipeline({
                  data: updated.data,
                  status: "fail",
                }),
              );

              setSnackbarState({
                open: true,
                message: "Error parsing JSON",
                severity: "error",
              });
              setJobTitles((prev) => ({
                ...prev,
                data: [],
                droppDown_value: "",
                value: "",
                job_value: "",
              }));
            }
          }
        }

        if (buffer) {
          const jsonResponse = JSON.parse(buffer);
          try {
            await processJsonResponse(jsonResponse, "internal");
          } catch (e) {
            let checkData = existing.data.map((item) => {
              return {
                ...item,
                file: {
                  ...item.file,
                  message: "Error during the request",
                  visible: true,
                },
              };
            });
            const updated = {
              ...existing,

              data: checkData,
              status: "fail",
            };

            localStorage.setItem(
              "Candidate BuildPipeline",
              JSON.stringify(updated),
            );
            dispatch(
              CandidateBuildPipeline({
                data: updated.data,
                status: "fail",
              }),
            );
            setSnackbarState({
              open: true,
              message: "Error parsing final JSON chunk",
              severity: "error",
            });
            setJobTitles((prev) => ({
              ...prev,
              data: [],
              droppDown_value: "",
              value: "",
              job_value: "",
            }));
          }
        }
      } catch (error) {
        let checkData = existing.data.map((item) => {
          return {
            ...item,
            file: {
              ...item.file,
              message: "Error during the request",
              visible: true,
            },
          };
        });
        const updated = {
          ...existing,
          data: checkData,
          status: "fail",
        };

        localStorage.setItem(
          "Candidate BuildPipeline",
          JSON.stringify(updated),
        );
        dispatch(
          CandidateBuildPipeline({
            data: updated.data,
            status: "fail",
          }),
        );
        setSnackbarState({
          open: true,
          message: "Error during the request",
          severity: "error",
        });
        setJobTitles((prev) => ({
          ...prev,
          data: [],
          droppDown_value: "",
          value: "",
          job_value: "",
        }));
      }
    }
  };

  const executeExternalUpload = async (validResumesData) => {
  const formData = new FormData();
  const generatedFiles = [];

  validResumesData.forEach((item) => {
    const base64Data = item.binary_text;
    const fileName = item.id || "file";
    const fileType = item.document_type?.toLowerCase() || "pdf";
    const byteCharacters = atob(base64Data);
    const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    let mimeType = "application/octet-stream";
    if (fileType === "pdf") mimeType = "application/pdf";
    else if (fileType === "docx")
      mimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    const blob = new Blob([byteArray], { type: mimeType });
    const file = new File([blob], `${fileName}.${fileType}`, { type: mimeType });
    generatedFiles.push(file);

    // ✅ Same as old code — append to correct formData key based on dropdown
    if (jobTitles.droppDown_value === "Add to Job") {
      formData.append("resume_file", file);
    } else {
      formData.append("files", file);
    }
  });

 
  if (jobTitles.droppDown_value === "Add to Job") {
    formData.append("id", jobTitles.value?.value);
  }

  const buildData = validResumesData.map((item, i) => {
    const f = generatedFiles[i];
    // Find matching selected row to preserve all original row data
    const selectedRow = checkSelected.externalSelect.find(
      (s) => s.ResumeID === item.id
    );
    return {
      ...(selectedRow || {}),
      result_title: "External Search Results",
      name: f.name,
      file: { name: f.name, progress: 1, buffer: 1, visible: false },
    };
  });

  const updated = { data: buildData, status: "Inprogress" };
  localStorage.setItem("Candidate BuildPipeline", JSON.stringify(updated));
  dispatch(CandidateBuildPipeline({ data: updated.data, status: "Inprogress" }));

  try {
    let response = {};
    if (jobTitles.droppDown_value === "Add to Job") {
      response = await UploadJob(formData);
    } else {
      response = await ResumeIntelligenceUpload(formData);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
   let streamBuffer = "";

    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      const chunk = decoder.decode(value, { stream: true });
      streamBuffer += chunk;
      let boundaryIndex;
      while ((boundaryIndex = streamBuffer.indexOf("}\n")) !== -1) {
        const jsonString = streamBuffer.slice(0, boundaryIndex + 1);
        streamBuffer = streamBuffer.slice(boundaryIndex + 1);
        const jsonResponse = JSON.parse(jsonString);
        try {
          await processJsonResponse(jsonResponse, "external");
        } catch (e) {
          const freshExisting =
            JSON.parse(localStorage.getItem("Candidate BuildPipeline")) || {};
          let checkData = freshExisting.data.map((item) => ({
            ...item,
            file:
              item.name === jsonResponse.current_resume
                ? { ...item.file, message: "Error during the request", visible: true }
                : item.file,
          }));
          const failUpdated = { data: checkData, status: "fail" };
          localStorage.setItem("Candidate BuildPipeline", JSON.stringify(failUpdated));
          dispatch(CandidateBuildPipeline({ data: failUpdated.data, status: "fail" }));
          setSnackbarState({ open: true, message: "Error parsing JSON", severity: "error" });
        }
      }
    }

    if (streamBuffer) {
      const jsonResponse = JSON.parse(streamBuffer);
      try {
        await processJsonResponse(jsonResponse, "external");
      } catch (e) {
        const freshExisting =
          JSON.parse(localStorage.getItem("Candidate BuildPipeline")) || {};
        let checkData = freshExisting.data.map((item) => ({
          ...item,
          file:
            item.name === jsonResponse.current_resume
              ? { ...item.file, message: "Error during the request", visible: true }
              : item.file,
        }));
        const failUpdated = { data: checkData, status: "fail" };
        localStorage.setItem("Candidate BuildPipeline", JSON.stringify(failUpdated));
        dispatch(CandidateBuildPipeline({ data: failUpdated.data, status: "fail" }));
        setSnackbarState({ open: true, message: "Error parsing final JSON chunk", severity: "error" });
      }
    }
  } catch (error) {
    const freshExisting =
      JSON.parse(localStorage.getItem("Candidate BuildPipeline")) || {};
    let checkData = freshExisting.data.map((item) => ({
      ...item,
      file: { ...item.file, message: "Error during the request", visible: true },
    }));
    const failUpdated = { data: checkData, status: "fail" };
    localStorage.setItem("Candidate BuildPipeline", JSON.stringify(failUpdated));
    dispatch(CandidateBuildPipeline({ data: failUpdated.data, status: "fail" }));
    setSnackbarState({ open: true, message: "Error during the request", severity: "error" });
  }
};
const handleAddCandidate = async () => {
  if (jobTitles.droppDown_value === null || jobTitles.value === null) {
    setJobTitles((prev) => ({ ...prev, value: "", droppDown_value: "" }));
    return;
  } else if (
    jobTitles.droppDown_value === "" ||
    (jobTitles.droppDown_value === "Add to Job" &&
      (jobTitles.value?.value === "" || jobTitles.value?.value === undefined))
  ) {
    return null;
  }
   setExternalValidating(true);
  try {
    const payload = {
      resumes: checkSelected?.externalSelect.map((item) => ({
        id: item.ResumeID,
        source: item.source,
        name: item.name,
      })),
    };
    const getData = await SeachExternalDataBaseRowClick(payload);
    const responses = getData?.data || [];

    const invalidResumes = responses.filter(
      (item) => !item.binary_text || item.binary_text === "none"
    );
    const validResumes = responses.filter(
      (item) => item.binary_text && item.binary_text !== "none"
    );

    if (invalidResumes.length > 0) {
      const invalidList = invalidResumes.map((r) => `• ${r.name}`).join("\n");

      if (validResumes.length === 0) {
        // ALL invalid — dialog only, no loading started
        setDialogErrorMessage(
          `The following profile(s) are missing document records and cannot be processed:\n\n${invalidList}`
        );
        setSelectDialog({
          open: true, disabled: false, changeStatusLoading: false,
          cancelLoading: false, changeLoading: false, value: "Active",
          id: "", condition: true, allInvalid: true,
        });
        return;
      }

      // SOME invalid — show dialog, don't start loading yet
      setDialogErrorMessage(
        `The following profile(s) are missing document records:\n\n${invalidList}\n\nWould you like to proceed with the remaining ${validResumes.length} valid profile(s)?`
      );
      setPendingValidResumes(validResumes);
      setSelectDialog({
        open: true, disabled: false, changeStatusLoading: false,
        cancelLoading: false, changeLoading: false, value: "Active",
        id: "", condition: true, allInvalid: false,
      });
    } else {
      // All valid — start loading and upload immediately
      await executeExternalUpload(validResumes);
    }
  } catch (error) {
    setSnackbarState({
      open: true,
      message: "An error occurred while inspecting remote candidate records.",
      severity: "error",
    });
  }
  finally {
    setExternalValidating(false);
  }
};
const handleProceedWithRemaining = async () => {
  const resumesToProcess = [...pendingValidResumes];
  setPendingValidResumes([]);
  setSelectDialog({
    open: false, disabled: false, changeStatusLoading: false,
    cancelLoading: false, changeLoading: false, value: "Active",
    id: "", condition: true, allInvalid: false,
  });
  await executeExternalUpload(resumesToProcess);
};



  const handleJobSelect = (value, index) => {
    if (index === 0) {
      setJobTitles((prev) => ({
        ...prev,
        job_value: value || "",
      }));
    } else
      setJobTitles((prev) => ({
        ...prev,
        value: value || "",
      }));
  };

  const handleBooleanStringEdit = (e, name) => {
    let value = e.target.value;
    setData((prev) => ({
      ...prev,
      search_strategy: { ...prev.search_strategy, [name]: value },
      full_message_data: prev.full_message_data.map((item, i) => {
        if (i === activeIndex.index) {
          return {
            ...item,
            search_strategy: { ...prev.search_strategy, [name]: value },
          };
        }
        return item;
      }),
    }));
  };

  const handleSelectType = (e) => {
    let value = e.target.value;
    setJobTitles((prev) => ({
      ...prev,
      droppDown_value: value || "",
    }));
  };

  const handlePrev = () => {
    const total = data.full_message_data.length;
    const newIndex = activeIndex.index > 0 ? activeIndex.index - 1 : total - 1;
    setActiveIndex((prev) => ({
      ...prev,
      index: newIndex,
      direction: "right",
    }));
    setData((prev) => ({
      ...prev,
      search_strategy: data.full_message_data[newIndex].search_strategy,
      cheat_sheet: data.full_message_data[newIndex].cheat_sheet,
      // search: data.full_message_data[newIndex].text,
      search: "",
    }));
  };

  const handleNext = () => {
    const total = data.full_message_data.length;
    const newIndex = activeIndex.index < total - 1 ? activeIndex.index + 1 : 0;
    setActiveIndex((prev) => ({
      ...prev,
      index: newIndex,
      direction: "left",
    }));
    setData((prev) => ({
      ...prev,
      search_strategy: data.full_message_data[newIndex].search_strategy,
      cheat_sheet: data.full_message_data[newIndex].cheat_sheet,
      // search: data.full_message_data[newIndex].text,
      search: "",
    }));
  };

  return (
    <Grid2
      container
      margin={"1rem 1rem 1rem 1.5rem"}
      padding={"1rem"}
      overflow={"hidden"}
      borderRadius={"10px"}
      backgroundColor="#fff"
      border={"1px solid rgba(0, 0, 0, 0.12)"}
      ref={ref}
    >
      <TabContext value={value}>
        <CommonGrid2 width={"100%"}>
          <CommonGrid2
            display={"flex"}
            flexWrap={"wrap"}
            justifyContent={"space-between"}
          >
            <Typography variant="h2">Build Pipeline</Typography>

            <CommonGrid2 display={"flex"} gap={"1rem"} alignItems={"center"}>
              {(data.search_enable || processConditionCheck) && (
                <CommonButton
                  value={"New Search"}
                  padding={"8px 1rem"}
                  variant="outlined"
                  fontWeight={"700"}
                  color="#344054"
                  border="#D0D5DD"
                  onClick={handleNewSearch}
                  disabled={
                    data.loading ||
                    data.search_external_loading ||
                    (candidateSourcing &&
                      candidateSourcing.data.length !== 0 &&
                      candidateSourcing.status === "Inprogress")
                  }
                />
              )}
              <TabViewSection
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="visible arrows tabs example"
                margin="0px"
                customStyle={{
                  background: "#F9FAFB !important",
                  padding: "5px",
                  borderRadius: "8px",
                  "& .MuiTab-root": {
                    minHeight: "34px",
                    padding: "6px 2rem",
                    fontWeight: 700,
                  },
                  "& .Mui-selected": {
                    background: "#7F56D9 !important",
                    margin: "0px",
                    color: "#fff !important",
                    boxShadow: "0px 0px 1px 0px #101828",
                    borderRadius: "5px",
                  },
                }}
              >
                {tabData.map((item, index) => (
                  <Tab label={item} value={index} disabled />
                ))}
              </TabViewSection>
            </CommonGrid2>
          </CommonGrid2>

          <TabPanelView
            value={0}
            padding={data.search_enable ? "1rem 0px 0px" : "0px"}
          >
            <Search
              headerData={headerData}
              data={data}
              handleSearch={handleSearch}
              handleEditSearch={handleEditSearch}
              handleSearchExternalDatabase={handleSearchExternalDatabase}
              handleSearchTableBodyData={handleSearchTableBodyData}
              handleAddCandidate={handleAddCandidate}
              candidateSourcing={candidateSourcing}
              checkSelected={checkSelected}
              processConditionCheck={
                candidateSourcing &&
                candidateSourcing.data.length !== 0 &&
                candidateSourcing.status === "Inprogress"
              }
              jobTitles={jobTitles}
              handleJobSelect={handleJobSelect}
              handleBooleanStringEdit={handleBooleanStringEdit}
              handleSelectType={handleSelectType}
              bounds={bounds}
              activeIndex={activeIndex}
              handleNext={handleNext}
              handlePrev={handlePrev}
              handleDetails={handleDetails}
              handleHubTableBodyData={handleHubTableBodyData}
              handleAddToJob={handleAddToJob}
              externalValidating={externalValidating}
            />
          </TabPanelView>

          <Slide
            direction="up"
            in={value === 1}
            timeout={500}
            mountOnEnter
            unmountOnExit
          >
            <TabPanelView value={1} padding="2rem 0px 0px">
              <Typography variant="h5">Search History</Typography>
              <CommonTable
                marginTop={"1.5rem"}
                data={[]}
                columns={historyHeaderData}
                handleTableBodyData={{}}
                paginationProps={{
                  count: 0,
                  page: 1,
                }}
              />
            </TabPanelView>
          </Slide>
        </CommonGrid2>
      </TabContext>
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
       <DialogCandidateHub
        open={statusDialog.open}
        handleButttonClose={handleChangeStatusClose}
        handleClose={handleChangeStatusClose}
        footer={<StatusFooter />}
        title={"Resume Document Missing"}
        content={dialogErrorMessage}
        titlepadding={"1rem 0px 0px"}
        minWidth="400px"
      />
    </Grid2>
  );
}
